import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "picture_in_picture",
  "use": "picture_in_picture-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"picture_in_picture\"><path d=\"M25.333 9.333H14.666v8h10.667v-8zM28 4H4a2.675 2.675 0 0 0-2.667 2.667v18.667c0 1.467 1.2 2.64 2.667 2.64h24c1.467 0 2.667-1.173 2.667-2.64V6.667C30.667 5.2 29.467 4 28 4zm0 21.347H4V6.64h24v18.707z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol